//
//
//
//
//

export default {
  data() {
    return {
      sTop: "",
      sHeight: ""
    };
  },
  props: {
    top: {
      type: String
    },
    height: {
      type: String
    },
    hasMore: {
      type: Boolean,
      default: true
    },
    reset: {
      // 是否重置内容，用于tab切换时，
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.sTop = this.top;
      this.sHeight = this.height;
      this.$refs.scrollerMore.finishInfinite(true);
    });
  },
  methods: {
    /**
     * 用户触发下拉刷下状态，监听该事件以获取加载新数据
     */
    onRefresh(done) {
      setTimeout(() => {
        this.$emit("onPulldown");
        done();
      }, 1000);
    },
    onInfinite(done) {
      if (this.hasMore == false) {
        setTimeout(() => {
          done(true);
        }, 1500);
        return;
      }
      setTimeout(() => {
        this.$emit("onScrollBottom");
        done();
      }, 1500);
    }
  },
  watch: {
    reset: function(e) {
      if (e) {
        // 如果为true,说明此滚动组件需要重新刷新，官方方法不好用，此处采用重新渲染页面方案
        // 解决当页面内容过长，向上滚动并切换数据后，内容数据上移问题
        this.$refs.scrollerMore.scrollTo(0, 0, true);
        this.$emit("update:reset", false);
      }
    }
  },
  components: {}
};



// WEBPACK FOOTER //
// ./src/components/ScrollMore.vue